import {

    GET_GENERIC_MESSAGE_LIST,
    GET_GENERIC_MESSAGE_LIST_SUCCESS,
  
    SAVE_GENERIC_MESSAGE_MASTER,
    SAVE_GENERIC_MESSAGE_SUCCESS,
  
    EDIT_GENERIC_MESSAGE,
    EDIT_GENERIC_MESSAGE_SUCCESS,
  
    UPDATE_GENERIC_MESSAGE,
    UPDATE_GENERIC_MESSAGE_SUCCESS,
  
    DELETE_GENERIC_MESSAGE,
    DELETE_GENERIC_MESSAGE_SUCCESS,
  
    GENERIC_MESSAGE_ERROR_ACTION,
    RESET_GENERIC_MESSAGE_STATE,
  
  } from "./actionType";
  
  
  const INIT_STATE = {
    GenericMessageList: [],
    PostData: { Status: false },
    deleteMessage: { Status: false },
    editData: { Status: false },
    updateMessage: { Status: false },
  
    saveBtnloading: false,
    listBtnLoading: false,
    goBtnLoading: false,
  };
  
  
  const GenericMessageReducer = (state = INIT_STATE, action) => {
  
    switch (action.type) {
  
      // 🔹 GET LIST
      case GET_GENERIC_MESSAGE_LIST:
        return {
          ...state,
          goBtnLoading: true,
        };
  
      case GET_GENERIC_MESSAGE_LIST_SUCCESS:
        return {
          ...state,
          GenericMessageList: action.payload,
          goBtnLoading: false,
        };
  
  
      // 🔹 SAVE
      case SAVE_GENERIC_MESSAGE_MASTER:
        return {
          ...state,
          saveBtnloading: true,
        };
  
      case SAVE_GENERIC_MESSAGE_SUCCESS:
        return {
          ...state,
          PostData: action.payload,
          saveBtnloading: false,
        };
  
  
      // 🔹 EDIT
      case EDIT_GENERIC_MESSAGE:
        return {
          ...state,
          listBtnLoading: action.config?.btnId,
        };
  
      case EDIT_GENERIC_MESSAGE_SUCCESS:
        return {
          ...state,
          listBtnLoading: false,
          editData: action.payload,
        };
  
  
      // 🔹 UPDATE
      case UPDATE_GENERIC_MESSAGE:
        return {
          ...state,
          saveBtnloading: true,
        };
  
      case UPDATE_GENERIC_MESSAGE_SUCCESS:
        return {
          ...state,
          updateMessage: action.payload,
          saveBtnloading: false,
        };
  
  
      // 🔹 DELETE
      case DELETE_GENERIC_MESSAGE:
        return {
          ...state,
          listBtnLoading: action.config?.btnId,
        };
  
      case DELETE_GENERIC_MESSAGE_SUCCESS:
        return {
          ...state,
          listBtnLoading: false,
          deleteMessage: action.payload,
        };
  
  
      // 🔹 ERROR
      case GENERIC_MESSAGE_ERROR_ACTION:
        return {
          ...state,
          saveBtnloading: false,
          listBtnLoading: false,
          goBtnLoading: false,
        };
  
      default:

      case RESET_GENERIC_MESSAGE_STATE:
        return {
          ...state,
          editData: { Status: false },
          PostData: { Status: false },
          deleteMessage: { Status: false },
          updateMessage: { Status: false },
          saveBtnloading: false,
          listBtnLoading: false,
          goBtnLoading: false,
        };
      



        return state;
    }
  };
  
  export default GenericMessageReducer;
  